export const corePdpLink = (slug: string, addressToken: string) =>
  `/properties/${encodeURIComponent(slug)}/aid_${addressToken}`;
